/* eslint-disable no-undef, no-unused-vars */
import { observer } from "mobx-react-lite";
import { useStore } from "../../../../root-store-context";
import { Button, Col, Row, Select } from "antd";
import { useEffect, useRef, useState } from "react";
import { RcFile } from "antd/es/upload";
import * as React from "react";
import { useCamIsMobile } from "hooks/useCamIsMobile";

export type RecipientsGeneralForm = {
  communityId: number;
  communitiesIds: number[];
  blocks: string[];
  inspectionGroups: string[];
};

export const RecipientsGeneral = observer(() => {
  const { applicationStore, modalViewerStore, stepByStepTabStore } = useStore();
  const isMobile = useCamIsMobile();
  const maxTagCount = isMobile ? 1 : undefined;
  const [formData, setFormData] = useState<RecipientsGeneralForm | undefined>(
    {} as RecipientsGeneralForm
  );

  const formDataRef = useRef(formData);
  useEffect(() => {
    formDataRef.current = formData;
  }, [formData]);

  useEffect(() => {
    if (stepByStepTabStore.currentStep === 3 && formDataRef.current) {
      const tempId = applicationStore.mailJob.files?.find(
        (_) => _.fileInfo.communityKey
      )?.fileInfo.communityKey;
      if (tempId && tempId !== formDataRef.current?.communityId) {
        setFormData({ communityId: tempId } as RecipientsGeneralForm);
        applicationStore.getGeneralFormData(tempId);
      }
    }
  }, [stepByStepTabStore.currentStep]);

  useEffect(() => {
  if (stepByStepTabStore.currentStep === 1) {
    setFormData({} as RecipientsGeneralForm);
  }
}, [stepByStepTabStore.currentStep]);

  const openViewFile = (file: RcFile) => {
    const blob = new Blob([file], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(blob);
    modalViewerStore.openFileByUrl(fileURL, "Recipient Info.pdf");
  };

  const styleSelect: React.CSSProperties = { width: "100%" };
  const labelSpan = isMobile ? 24 : 8;
  const selectSpan = isMobile ? 24 : 16;
  const rowMarginBottom = isMobile ? 12 : 8;
  const rowGutter: [number, number] = isMobile ? [0, 4] : [16, 16];

  return (
    <div className="cam__recipients-general">
      <Row gutter={rowGutter} style={{ marginBottom: rowMarginBottom }}>
        <Col span={labelSpan}><b>Select or enter Property:</b></Col>
        <Col span={selectSpan}>
          <Select
            data-testid="cam-community-id-select"
            style={styleSelect}
            value={formData?.communityId}
            options={applicationStore.communities.map((_) => ({
              value: _.id,
              label: _.titleInDropdown,
            }))}
            disabled
          />
        </Col>
      </Row>
      <Row gutter={rowGutter} style={{ marginBottom: rowMarginBottom }}>
        <Col span={labelSpan}><b>Select Communities</b></Col>
        <Col span={selectSpan}>
          <Select
            data-testid="cam-communities-select"
            style={styleSelect}
            mode="multiple"
            maxTagCount={maxTagCount}
            options={applicationStore.communityForPropertyList.map((_) => ({
              value: _.communityKey,
              label: _.co_Name,
            }))}
            value={formData?.communitiesIds ?? []}
            onChange={(changedValues) => {
              setFormData({
                ...formData,
                communitiesIds: changedValues,
              } as RecipientsGeneralForm);
              applicationStore.mailJob.files?.forEach((_) => {
                applicationStore.setSelectedFileData(_.guid, {
                  communitiesKeys: changedValues,
                });
              });
            }}
            loading={applicationStore.isLoadCommunitiesData}
            disabled={applicationStore.isLoadCommunitiesData}
          />
        </Col>
      </Row>
      <Row gutter={rowGutter} style={{ marginBottom: rowMarginBottom }}>
        <Col span={labelSpan}><b>Block Search</b></Col>
        <Col span={selectSpan}>
          <Select
            data-testid="cam-block-select"
            style={styleSelect}
            mode="multiple"
            maxTagCount={maxTagCount}
            options={applicationStore.communityBlockList.map((_) => ({
              value: _.item1,
              label: _.item2,
            }))}
            value={formData?.blocks ?? []}
            onChange={(changedValues) => {
              setFormData({
                ...formData,
                blocks: changedValues,
              } as RecipientsGeneralForm);
              applicationStore.mailJob.files?.forEach((_) => {
                applicationStore.setSelectedFileData(_.guid, {
                  blocks: changedValues,
                });
              });
            }}
            loading={applicationStore.isLoadCommunitiesData}
            disabled={applicationStore.isLoadCommunitiesData}
          />
        </Col>
      </Row>
      <Row gutter={rowGutter} style={{ marginBottom: rowMarginBottom }}>
        <Col span={labelSpan}><b>Inspection Group</b></Col>
        <Col span={selectSpan}>
          <Select
            data-testid="cam-inspection-group-select"
            style={styleSelect}
            mode="multiple"
            maxTagCount={maxTagCount}
            options={applicationStore.communityGroupeList.map((_) => ({
              value: _.item1,
              label: _.item2,
            }))}
            value={formData?.inspectionGroups ?? []}
            onChange={(changedValues) => {
              setFormData({
                ...formData,
                inspectionGroups: changedValues,
              } as RecipientsGeneralForm);
              applicationStore.mailJob.files?.forEach((_) => {
                applicationStore.setSelectedFileData(_.guid, {
                  inspectionGroup: changedValues,
                });
              });
            }}
            loading={applicationStore.isLoadCommunitiesData}
            disabled={applicationStore.isLoadCommunitiesData}
          />
        </Col>
      </Row>
      {applicationStore.mailJob.files?.map((el) => (
        <Row
          gutter={[16, 16]}
          key={el.guid}
          style={{ marginLeft: 4, marginRight: 4, marginBottom: 6 }}
        >
          <Col span={24}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); openViewFile(el.file); }}
                style={{ flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
              >
                {el.name}
              </a>
              <Button
                data-testid={`cam-delete-file-btn-${el.guid}`}
                className="cam__button-danger-sm"
                type="primary"
                danger
                style={{ flexShrink: 0 }}
                onClick={() => {
                  applicationStore.setSelectedFiles([el.guid]);
                  applicationStore.deleteFiles();
                }}
              >
                Delete
              </Button>
            </div>
          </Col>
        </Row>
      ))}
    </div>
  );
});